import * as React from 'react';
import "./ofooter.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faClipboard, faHome } from "@fortawesome/free-solid-svg-icons";
import { observer } from 'mobx-react';
import { useStores } from '../../Stores/MainStore';

const OFooter = observer(() => {

    const { ConfigStore } = useStores();

    const handleClick = (buttonId) => {
        ConfigStore.setActiveownButton(buttonId);
    };

    return(
        <footer className="ofooter">
            <div
                className="footer__icon icon_me"
                style={{ background: ConfigStore.activeownButton === 1 ? 'rgba(255, 255, 255, 0.15)' : 'transparent' }}
                onClick={() => handleClick(1)}
            >
                <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
                <p>me</p>
            </div>
            <div
                className="footer__icon icon_qr"
                style={{ background: ConfigStore.activeownButton === 2 ? 'rgba(255, 255, 255, 0.15)' : 'transparent' }}
                onClick={() => handleClick(2)}
            >
                <FontAwesomeIcon icon={faClipboard}></FontAwesomeIcon>
                <p>offers</p>
            </div>
            <div
                className="footer__icon icon_home"
                style={{ background: ConfigStore.activeownButton === 3 ? 'rgba(255, 255, 255, 0.15)' : 'transparent' }}
                onClick={() => handleClick(3)}
            >
                <FontAwesomeIcon icon={faHome}></FontAwesomeIcon>
                <p>home</p>
            </div>
        </footer>
    );
});

export default OFooter;